import {capitalize, mergeProperties} from "../components/Utility";

export const  loginFormModel = (data) => {
    const initialData = {
        phone: '',
        password: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};


export const getDetailData = ({item,userRole}) => {
    if (!item) return { details: {} };
    return {
        details: {
            name: `${capitalize(item?.fName)} ${capitalize(item?.lName)}`,
            email: item?.email,
            phone: item?.phone,
            role: [
                userRole?.scope,
                userRole?.role,
                userRole?.scopeName && `(${userRole.scopeName})`
            ].filter(Boolean).join(' ')
            /*access: item.userRole && item.userRole.length > 0 ? item.userRole.map(role => (`${role.scopeId.name} (${role.scope} ${role.role})`)).join(', ') : item?.role,*/
        }
    };
}



